/**
 * `chore.steps` arrives in two shapes depending on which Phoenix codepath
 * built the row: sometimes a real JSON array, sometimes a stringified JSON
 * blob (legacy serializer). Treating it as an array unconditionally crashes
 * the renderer — `"[...]".sort` is a TypeError, and `"[...]".length` is the
 * string's character count, not the step count.
 *
 * Every consumer of `chore.steps` in the UI must route through this helper.
 */
export interface ChoreStep {
  position: number
  text: string
}

export const parseChoreSteps = (raw: unknown): ChoreStep[] => {
  if (Array.isArray(raw)) return raw as ChoreStep[]
  if (typeof raw === 'string' && raw.trim().length > 0) {
    try {
      const parsed = JSON.parse(raw)
      return Array.isArray(parsed) ? (parsed as ChoreStep[]) : []
    } catch {
      return []
    }
  }
  return []
}

/** Convenience: ordered by `position`. */
export const sortedChoreSteps = (raw: unknown): ChoreStep[] =>
  parseChoreSteps(raw)
    .slice()
    .sort((a, b) => (a.position ?? 0) - (b.position ?? 0))
